<template>
    <span>
        <v-btn
            v-if="
                $page.props.auth.user &&
                    (meet.created_by === $page.props.auth.user.id || $page.props.auth.user.id === 1)
            "
            style="margin-top: -2px"
            icon
            small
            @click.stop="dialog = true"
        >
            <v-icon small>mdi-pen</v-icon>
        </v-btn>

        <v-dialog v-model="dialog" persistent max-width="600px">
            <v-card :loading="saving">
                <v-card-title>
                    <span class="text-h5">Edit {{ model.title }}</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12" sm="6" md="6">
                                <!--                            <v-datetime-picker label="Start" v-model="start" date-format="iii M/d" time-format="h:mm a" />-->
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <!--                            <v-datetime-picker label="End" v-model="end" date-format="iii M/d" time-format="h:mm a" />-->
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey darken-1" text @click="dialog = false"> Close </v-btn>
                    <v-btn color="primary" text @click="save"> Save </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </span>
</template>

<script>
import Model from '@/Models/Model.js';
import Session from '@/Models/Session.js';
import Meet from '@/Models/Meet.js';
import { formatJSDate } from '@/helpers.js';
// import  VueDateTimePicker from 'vuetify-datetime-picker';

export default {
    name: 'ChangeTimes',

    components: {
        // VueDateTimePicker,
    },

    props: {
        model: {
            type: Model,
            required: true,
        },

        previous: {
            type: Model,
            required: false,
            default: null,
        },

        meet: {
            type: Meet,
            required: true,
        },

        modelClass: {
            type: Function,
            required: true,
        },

        timezone: {
            type: String,
            required: true,
        },
    },

    data: () => ({
        dialog: false,
        saving: false,

        start: null,
        end: null,
    }),

    computed: {
        payload() {
            return {
                model_type: this.model instanceof Session ? 'App\\Models\\Session' : 'App\\Models\\Flight',
                model_id: this.model.id,
                starts_at: this.$moment.tz(this.start, this.timezone).utc().format('YYYY-MM-DD HH:mm:ss'),
                ends_at: this.$moment.tz(this.end, this.timezone).utc().format('YYYY-MM-DD HH:mm:ss'),
            };
        },
    },

    created() {
        if (this.model.starts_at) {
            this.start = this.model.timestamp('starts_at').toDate();
        } else if (this.previous?.ends_at) {
            this.start = this.previous.timestamp('ends_at').toDate();
        } else {
            this.start = this.$moment(this.meet.start_date).hour(8).toDate();
        }

        if (this.model.ends_at) {
            this.end = this.model.timestamp('ends_at').toDate();
        } else {
            this.end = this.$moment(this.start).add(1, 'hour').toDate();
        }
    },

    methods: {
        async save() {
            this.saving = true;

            const payload = {
                model_type: this.model instanceof Session ? 'App\\Models\\Session' : 'App\\Models\\Flight',
                model_id: this.model.id,
                starts_at: this.$moment.tz(formatJSDate(this.start), this.timezone).utc().format('YYYY-MM-DD HH:mm:ss'),
                ends_at: this.$moment.tz(formatJSDate(this.end), this.timezone).utc().format('YYYY-MM-DD HH:mm:ss'),
            };

            const response = await this.modelClass.api().put('/api/change-times', payload);

            this.saving = false;

            this.$emit('changed', response.entities.sessions[0]);

            this.dialog = false;
        },

        reset() {
            this.start = null;
            this.end = null;
        },
    },
};
</script>
